<template>
    <layout>
        <div class="w-100">
            <div class="row justify-content-center">
                <div class="col-10 col-sm-7 col-md-5 col-lg-8 col-xl-7 col-xxl-6 login-wrapper py-5">
                    <div class="mx-auto login-w-limit">
                        <div class="logo-wrapper text-center mb-2">
                            <img src="@/assets/img/bau-logo-for-light.svg" height="35"/>
                        </div>
                        <h4 class="text-center mb-5" style="min-height: 50px;">
                            {{ $t('ulmer') }} {{ $t('application_system') }}
                        </h4>
                        <div class="fadeIn">
                            <ValidationObserver ref="form">
                                <div class="mx-auto">
                                    <ValidationProvider name="username" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('national_id')">
                                            <b-form-input type="text"
                                                          v-mask="'###########'"
                                                          v-model="national_id"
                                                          :state="errors[0] ? false : null"/>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                    <div class="d-flex justify-content-center mb-4">
                                        <b-button variant="primary" block @click="sendVerify">
                                            {{ $t('login').toUpper() }}
                                        </b-button>
                                    </div>
                                    <div class="d-flex justify-content-center mb-4">
                                        <b-button variant="outline-primary" block @click="goToRegister">
                                            {{ $t('sign_up') }}
                                        </b-button>
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
            <vue-recaptcha ref="recaptchaLogin" size="invisible" sitekey="6LcMe7IrAAAAANoOlSMkWztH9_KFU5Ofj7jUK7n7" />
            <CommonModal ref="smsVerification" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="clear">
                <template v-slot:CommonModalTitle>
                    <template>
                        {{ $t('verification').toUpperCase() }}
                    </template>
                </template>
                <template v-slot:CommonModalContent>
                    <div class="mb-3">
                        <ValidationObserver ref="formSmsVerify">
                            <ValidationProvider name="pin" rules="required" v-slot="{valid, errors}">
                                <sms-input v-model="pin"
                                           ref="smsInput"
                                           :timerFrom="timer"
                                           @timerExpired="timerExpired"
                                />
                            </ValidationProvider>
                        </ValidationObserver>
                        <div class="d-flex justify-content-end mt-2">
                            <ProcessingButton v-if="timer===0" :label="$t('resend_code')" :variant="'link'" :processing="process" @click="sendVerify"/>
                        </div>
                        <div>
                            <ProcessingButton v-if="timer>0" :disabled="pin==null"  :label="$t('verify')" :processing="process" class="d-flex justify-content-center align-item-center w-100 mt-4" @click="verify"/>
                        </div>
                    </div>
                </template>
            </CommonModal>

        </div>
    </layout>
</template>

<script>
import Layout from '@/modules/ulmerCertificatesApplicationForm/layout/Layout'
import PasswordInput from '@/components/elements/PasswordInput'
import { VueRecaptcha } from 'vue-recaptcha'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import SmsInput from "@/components/elements/SmsInput.vue";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import UlmerCertificatesApplicationsServices from "@/services/UlmerCertificatesApplicationsServices";

export default {
    name: "Login",
    components: {
        ProcessingButton, SmsInput,
        Layout,
        PasswordInput,
        VueRecaptcha,
        ValidationObserver,
        ValidationProvider
    },
    metaInfo() {
        return {
            title: 'Ulmer ' + this.$t('application_system'),
        };
    },
    data() {
        return {
            timer:0,
            pin:null,
            process: false,
            footerInfo: null,
            national_id:null,
            expiryIn:0,
        }
    },
    mounted() {
        this.expiryIn=this.$store.getters['UlmerCertificatesApplication/getExpiryIn']
    },
    methods: {
        clear(){
            this.pin=null
            this.timer=0
        },
        goToRegister() {
            this.$router.push('/certificates/application/register');
        },
       async sendVerify() {
            const isValid =await this.$refs.form.validate();
            if (!isValid) return
           try {
               this.process=true
               const res =await UlmerCertificatesApplicationsServices.login({national_id:this.national_id})
               this.$toast.success(this.$t('api.' + res.data.data.message))
               this.timer=res.data.data.express_in
               this.$refs.smsVerification.$refs.commonModal.show()
           }catch (err){
                this.showErrors(err,null)
            }finally {
                this.process=false
            }
        },

        async verify(){
            const isValid =await this.$refs.formSmsVerify.validate();
            if (!isValid) return
            try {
                this.process=true
                const res =await UlmerCertificatesApplicationsServices.verifyLogin({national_id:this.national_id,pin:this.pin})
                await this.$store.dispatch('UlmerCertificatesApplication/setSessionDeadline')
                this.setWithExpiry('ulmer_application_data', res.data.data, this.expiryIn, true)
                setTimeout(async ()=>{
                    await this.$router.push('/certificates/application/form');
                },1000)
            }catch (err){
                this.showErrors(err,null)
            }finally {
                this.process=false
            }
        },
        timerExpired(){
            this.timer=0
        }
    }
}
</script>

<style scoped>
</style>
